/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { Observer, Subscription } from 'rxjs';
import { LayoutConfigModel, LayoutConfigService, SplashScreenService, TranslationService } from './@core/layout';
import { NavigationEnd, Router } from '@angular/router';
import { LoginPageService } from './shared/services/login-page.service';
import { DOCUMENT } from '@angular/common';
import {distinctUntilChanged, finalize, tap} from 'rxjs/operators';
import { Observable } from 'rxjs-compat';
// language list
import { locale as enLang } from './@core/config/i18n/en';
import { locale as chLang } from './@core/config/i18n/ch';
import { locale as esLang } from './@core/config/i18n/es';
import { locale as jpLang } from './@core/config/i18n/jp';
import { locale as deLang } from './@core/config/i18n/de';
import { locale as frLang } from './@core/config/i18n/fr';
import { locale as vnLang } from './@core/config/i18n/vn';
import {UserTreeService} from "./@core/services/user-tree.service";
import {TranslateService} from "@ngx-translate/core";
import {NbMenuService, NbSidebarService} from "@nebular/theme";


const LAYOUT_LOGINS = ['login-v1','login-v2','login-v3'];
const LOGIN_DEFAULT:string =  "login-v1";
@Component({
  selector: 'ngx-app',
  template: `<router-outlet></router-outlet>`,
  styles: [':host{height: 100%;margin: 0;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

  // constructor(private analytics: AnalyticsService, private seoService: SeoService) {
  // }

  // ngOnInit(): void {
  //   this.analytics.trackPageViews();
  //   this.seoService.trackCanonicalChanges();
  // }

  // Public properties
	title = 'Metronic';
	loader: boolean;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	private configLayout: LayoutConfigModel;
	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(private translationService: TranslationService,
				private router: Router,
				private layoutConfigService: LayoutConfigService,
				private splashScreenService: SplashScreenService,
				private loginPageService: LoginPageService,
        private userTreeService: UserTreeService,
        private sidebarService: NbSidebarService,
        private menuService: NbMenuService,
				private cdr: ChangeDetectorRef,
				private analytics: AnalyticsService, private seoService: SeoService,
				@Inject(DOCUMENT) private _document: HTMLDocument) {

		// register translations

		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang,vnLang);
		this.configLayout = this.layoutConfigService.getConfig();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
    this.menuService.onItemClick().pipe(distinctUntilChanged())
      .subscribe( (menuBag) => {
        if (menuBag.item.data && menuBag.item.data.user_tree) {
          this.sidebarService.toggle(false, 'user-sidebar');
          this.userTreeService.open();
        }
      });
		this.analytics.trackPageViews();
    	this.seoService.trackCanonicalChanges();
		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// hide splash screen
				// this.splashScreenService.hide();

				// scroll to top on every route change
				window.scrollTo(0, 0);

				// to display back the body content
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
		});
		this.unsubscribe.push(routerSubscription);

		let currentHost = location.hostname;
		this.loginPageService.host(currentHost).pipe(
			tap(result => {
				if (result.data) {
					this.configLayout.self.logo.dark = result.data.logoUrl;
					this.configLayout.self.logo.light = result.data.logoUrl;
					let layout = LAYOUT_LOGINS.find(x=>x ==  result.data.layout);

					// set layout login
					if(!layout) layout = LOGIN_DEFAULT;
					this.configLayout.self.login =  layout;//layout;
					this.configLayout.self["loginpage"] = result.data;

					// set title
					this._document.getElementById('appTitle').innerText = result.data.title || "Payment";

					// set icon
					if(result.data.iconUrl){
						this.configLayout.self.icon = result.data.iconUrl;
						this.getBase64ImageFromURL(this.configLayout.self.icon).subscribe(base64data=>{
							this._document.getElementById('appFavicon').setAttribute('href', base64data);
						})

					}
					this.layoutConfigService.setConfig(this.configLayout, true);
				}
				else {
					// this.configLayout.self.login = "not-support";
					this.configLayout.self.login = LOGIN_DEFAULT;
					this._document.getElementById('appTitle').innerText = "Payment";
					this.configLayout.self.icon = "http://navitrack.camdvr.org:9000/tracking/loginPage/splash_logo.svg_1705465049_.svg?AWSAccessKeyId=admin&Expires=4861138649&Signature=UtG9JCv4InEtvMB2E7iJPUSJO%2B0%3D";
						this.getBase64ImageFromURL(this.configLayout.self.icon).subscribe(base64data=>{
							this._document.getElementById('appFavicon').setAttribute('href', base64data);
						})

					this.layoutConfigService.setConfig(this.configLayout, true);
				}
			}
			),
			finalize(() => {
				this.cdr.markForCheck();
				this.cdr.detectChanges();
				this.splashScreenService.hideGlobalSpinner();

			})
		).toPromise();
	}

	hideGlobalSpinner(){
		this._document.getElementById('nb-global-spinner').setAttribute('style','display:none');
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
	getBase64ImageFromURL(url: string) {
		return Observable.create((observer: Observer<string>) => {
		  // create an image object
		  let img = new Image();
		  img.crossOrigin = 'Anonymous';
		  img.src = url;
		  if (!img.complete) {
			  // This will call another method that will create image from url
			  img.onload = () => {
			  observer.next(this.getBase64Image(img));
			  observer.complete();
			};
			img.onerror = (err) => {
			   observer.error(err);
			};
		  } else {
			  observer.next(this.getBase64Image(img));
			  observer.complete();
		  }
		});
	 }
	 getBase64Image(img: HTMLImageElement) {
		// We create a HTML canvas object that will create a 2d image
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
		var ctx = canvas.getContext("2d");
		// This will draw image
		ctx.drawImage(img, 0, 0);
		// Convert the drawn image to Data URL
		var dataURL = canvas.toDataURL("image/png");
	 	return dataURL;
	 }
}
